import { Box, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { forwardRef } from "react"
import { RoadmapItem } from "../newsTypes"
import { useDateTime } from "../../localization/useDateTime"
import { Stack } from "@mui/system"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { Link } from "react-router-dom"
import { faArrowRight } from "@fortawesome/pro-light-svg-icons"

const useStyles = makeStyles()((theme) => ({
    card: {
        backgroundColor: theme.palette.grey[200],
        padding: "1rem",
        marginBottom: "1.25rem",
    },
    header: {
        display: "flex",
        alignItems: "center",
    },
    date: {
        color: theme.palette.text.secondary,
        fontSize: "0.875rem",
    },
    title: {
        fontSize: "1.825rem",
        fontWeight: 400,
        color: theme.palette.text.primary,
        lineHeight: 1.14,
    },
    link: {
        color: theme.palette.text.secondary,
        textDecoration: "none",
        fontSize: "0.875rem",
        "&:hover": {
            textDecoration: "underline",
            color: theme.palette.primary.main,
        },
    },
    linkContainer: {
        flexDirection: "row",
        marginTop: "1.5rem",
        alignItems: "center",
        gap: "0.625rem",
        textDecoration: "none",
    },
    dot: {
        margin: "0 .5rem",
        color: "#94A3B8",
    },
    type: {
        color: theme.palette.tailwind.green[800],
        fontSize: "0.75rem",
        lineHeight: 1.66,
        fontWeight: 700,
        textTransform: "capitalize",
    },
}))

interface RoadmapFeatureCardProps {
    item: RoadmapItem
    isUser?: boolean
}

export const RoadmapFeatureCard = forwardRef<HTMLDivElement, RoadmapFeatureCardProps>(({ item, isUser }, ref) => {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const formattedDate = dateTimeFactory.formatDate(dateTimeFactory.fromApi(item.publishDate))

    return (
        <Box className={classes.card} ref={ref} data-permalink={item.permaLink}>
            <Stack gap="1rem">
                <Box className={classes.header}>
                    <Typography variant="caption" className={classes.date}>
                        {formattedDate}
                    </Typography>
                    {!isUser && item.roadmapDetails.implementationType && (
                        <>
                            <FontAwesomeIcon className={classes.dot} width=".25rem" icon={faCircle} />
                            <Typography className={classes.type}>
                                {item.roadmapDetails.implementationType.toLowerCase()}
                            </Typography>
                        </>
                    )}
                </Box>

                {item.subject && <Typography className={classes.title}>{item.subject}</Typography>}

                {item.shortDescription && (
                    <Typography variant="body2" color="textPrimary">
                        {item.shortDescription}
                    </Typography>
                )}
            </Stack>

            <Link to={item.permaLink} className={classes.link} target="_blank" rel="noopener noreferrer">
                <Stack className={classes.linkContainer}>
                    <LocalizedStrict id="news-gopay-read-more">
                        <Typography variant="body2">Read more</Typography>
                    </LocalizedStrict>
                    <FontAwesomeIcon icon={faArrowRight} />
                </Stack>
            </Link>
        </Box>
    )
})

RoadmapFeatureCard.displayName = "RoadmapFeatureCard"
